<template>
  <div>
    <banner-table></banner-table>
  </div>
</template>

<script>
import BannerTable from '../components/administracia/BannerTable.vue';

export default {
  components: {
    BannerTable,
  },
  data() {
    return {};
  },
};
</script>
<style lang="sass"></style>
